(function () {
  angular.module('leanlaw').directive('backLink', backLinkController);
  backLinkController.$inject = [];
  function backLinkController() {
    return {
      restrict: 'EA',
      scope: {
        route: '@'
      },
      template: require("./views/backLink.html")
    };
  }
})();